import sysInstance_status from '@/utils/projectUtil/projectDictUtil/data/sysInstance_status'
import product_status from "@/utils/projectUtil/projectDictUtil/data/product_status";
import product_category from "@/utils/projectUtil/projectDictUtil/data/product_category";
import product_nodeType from "@/utils/projectUtil/projectDictUtil/data/product_nodeType";
import product_networkType from "@/utils/projectUtil/projectDictUtil/data/product_networkType";
import product_dataType from "@/utils/projectUtil/projectDictUtil/data/product_dataType";
import product_dataCheckLevel from "@/utils/projectUtil/projectDictUtil/data/product_dataCheckLevel";
import product_authMode from "@/utils/projectUtil/projectDictUtil/data/product_authMode";
import device_deviceStatus from "@/utils/projectUtil/projectDictUtil/data/device_deviceStatus";
import sysInstance_areaCode from "@/utils/projectUtil/projectDictUtil/data/sysInstance_areaCode";


let data = {
  'sysInstance.status': sysInstance_status,
  'sysInstance.areaCode': sysInstance_areaCode,

  'product.status': product_status,
  'product.category': product_category,
  'product.nodeType': product_nodeType,
  'product.networkType': product_networkType,
  'product.dataType': product_dataType,
  'product.dataCheckLevel': product_dataCheckLevel,
  'product.authMode': product_authMode,

  'device.deviceStatus': device_deviceStatus,
}


export const getDictList = (dictIdentity) => {
  return data[dictIdentity] || [];
}

export const getDictMap = (dictIdentity) => {
  let list = getDictList(dictIdentity)
  let map = {}
  list.forEach(item => {
    map[item.value + ''] = item.label
  })
  return map;
}

export const getDictLabel = (dictIdentity, value) => {
  let map = getDictMap(dictIdentity)
  return map[value + ''] || ''
}

export default {
  getDictList,
  getDictMap,
  getDictLabel,
}
